import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-final-form';
import ErrorMessage from '../common/ErrorMessage';
import { useUser } from '../contexts/UserContext';
import AddEditForm from './AddEditForm';
import { validateGatedFeaturesForSubmit } from './FeatureCheckboxes';

type AddModalProps = {
  onClose(): void;
  onSave(formData: Record<string, unknown>, pendingFacilityConfigurations: Record<string, string>): Promise<any>;
};

const AddModal: React.FC<AddModalProps> = (props) => {
  const user = useUser();

  const initialValues = {
    communicationsEnabled: false,
    featureTexting: false,
    textingLocalStatus: false,
    audioCallingEnabled: false,
    videoCallingEnabled: false,
    pendingFacilityConfigurations: {} as Record<string, string>,
  };

  return (
    <Modal show={true} onHide={props.onClose} size="xl">
      <Form
        initialValues={initialValues}
        onSubmit={(formData: Record<string, unknown>) => {
          // This needs to be sent as enable/disabled rather than a boolean
          formData.textingLocalStatus = formData.textingLocalStatus ? EnabledDisabled.ENABLED : EnabledDisabled.DISABLED;
          const validationMessage = validateGatedFeaturesForSubmit(
            formData as { features?: unknown; pendingFacilityConfigurations?: Record<string, string> },
            []
          );
          if (validationMessage != null) {
            return { [FORM_ERROR]: validationMessage };
          }
          const pendingFacilityConfigurations =
            (formData.pendingFacilityConfigurations as Record<string, string> | undefined) ?? {};
          const facilityPayload = { ...formData };
          delete facilityPayload.pendingFacilityConfigurations;
          return props.onSave(facilityPayload, pendingFacilityConfigurations);
        }}
        mutators={{
          disableCommunicationOptions: (args, state, utils) => {
            utils.changeValue(state, 'featureTexting', () => false);
            utils.changeValue(state, 'textingLocalStatus', () => false);
            utils.changeValue(state, 'audioCallingEnabled', () => false);
            utils.changeValue(state, 'videoCallingEnabled', () => false);
          },
        }}
        render={(form) =>
          <form onSubmit={form.handleSubmit}>
            <Modal.Header>Add Facility</Modal.Header>
            <Modal.Body>
              <AddEditForm form={form} user={user} />
            </Modal.Body>

            <Modal.Footer>
              {form.hasValidationErrors && form.submitFailed &&
                <div style={{ flex: '0 0 100%' }}>
                  <ErrorMessage message="Please fix the invalid fields before submitting" />
                </div>
              }

              <Button
                variant="default"
                type="button"
                disabled={form.submitting}
                onClick={props.onClose}>
                Cancel
              </Button>
              <Button
                variant="primary"
                disabled={form.submitting}
                type="submit">
                Save
              </Button>
            </Modal.Footer>
          </form>
        } />
    </Modal>
  );
};

export default AddModal;
